export default "__VITE_ASSET__DVQaNc4j__"